import $ from 'jquery';

$(function(){

	$('body.team .teamcarousel').slick({
		autoplay: true,
		autoplaySpeed: 4000,
		arrows: false	
	});
	
});